import React, { useEffect, useState } from "react";
import "./Title.css";
import { ExpandMoreIcon, NotificationsNoneOutlinedIcon } from "../icons/Icons";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInstance";
import { LogoutOutlined } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { logout } from "../../state/authSlice";
import LoadingComponent from "../loading/Loading";
import LogoutModal from "../logout/LogoutModal";
import { persistor } from "../../state/store";

interface TitleComponentProps {
  title: string;
}

const TitleComponent: React.FC<TitleComponentProps> = ({ title }) => {
  const [personalDetails, setPersonalDetails] = React.useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const dispatch = useDispatch();

  const handleLogout = async () => {
    setLoading(true);
    dispatch(logout());
    await persistor.purge(); // Wait for persist to clear storage
    window.location.href = "/login";
  };

  const fetchPersonalDetails = async () => {
    try {
      const response = await axiosInstance.get("/auth/me");
      setPersonalDetails(response.data.data);
      console.log(response.data.data);
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch personal details.";
      toast.error(errorMessage);
      console.error("Error fetching personal details:", error);
    }
  };

  useEffect(() => {
    fetchPersonalDetails();
  }, []);

  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <div className="title-component">
      <h4 className="title-text">{title}</h4>
      <div className="title__profile__section">
        <div>
          <NotificationsNoneOutlinedIcon />
        </div>
        <a href="/profile">
          <img
            src={
              personalDetails?.avatar ||
              `https://ui-avatars.com/api/?name=${encodeURIComponent(
                personalDetails?.full_name || "User"
              )}&background=4caf50&color=fff`
            }
            alt="avatar"
          />
        </a>
        {/* <ExpandMoreIcon /> */}
        <div onClick={() => setShowLogoutModal(true)}>
          <LogoutOutlined />
        </div>
      </div>
      <LogoutModal
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        onLogout={handleLogout}
      />
    </div>
  );
};

export default TitleComponent;
